import { useContext } from "react";
import secondaryComponents from "../..";
import { useDeleteTerminals } from "../../../../hooks/api/mutations/useTerminals";
import { ToastContext } from "../../../../hooks/context";

export const DeleteIntegratedDevice = ({
  terminalDetails = null,
  closeModal = () => {},
}) => {
  const triggerToast = useContext(ToastContext);
  const { mutate: deleteTerminalMutate, isLoading } = useDeleteTerminals();
  const deleteTerminal = () => {
    deleteTerminalMutate(
      { id: terminalDetails?.id },
      {
        onSuccess: () => {
          triggerToast("Terminal deletion successful", "success");
          closeModal();
        },
      },
    );
  };

  return (
    <secondaryComponents.DeletePrompt
      title="Are you sure you want to delete this terminal"
      onClose={closeModal}
      onSubmit={deleteTerminal}
      isSubmiting={isLoading}
    >
      <h5>
        Terminal Details:{" "}
        <span className="gray--text font-weight-normal">
          {terminalDetails?.terminal_id}
        </span>
      </h5>
      <h5>
        Serial Number:{" "}
        <span className="gray--text font-weight-normal">
          {terminalDetails?.terminal_sn}
        </span>
      </h5>
      <h5>
        Merchant ID:{" "}
        <span className="gray--text font-weight-normal">
          {terminalDetails?.merchant_id}
        </span>
      </h5>
    </secondaryComponents.DeletePrompt>
  );
};
